export default __webpack_public_path__ + "static/media/バーボン.6ffedb8d.PNG";